
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":"0.5"}},[_c('path',{attrs:{"d":"M3 7C3 4.23858 5.23858 2 8 2C10.7614 2 13 4.23858 13 7V12H3V7Z","fill":"#9095A5"}}),_c('rect',{attrs:{"x":"3","y":"10","width":"12","height":"2","fill":"#9095A5"}}),_c('path',{attrs:{"d":"M6 14H10C10 15.1046 9.10457 16 8 16C6.89543 16 6 15.1046 6 14Z","fill":"#9095A5"}}),_c('rect',{attrs:{"x":"7","width":"2","height":"3","rx":"1","fill":"#9095A5"}}),_c('path',{attrs:{"d":"M15 2L3 14","stroke":"#F8F8FA","stroke-width":"2"}}),_c('path',{attrs:{"d":"M13 1L1 13","stroke":"#9095A5","stroke-width":"2"}})])])
          )
        }
      }
    